<template>
    <div>
        <div class="page-title">
            <h4> Editeaza rolul : {{ this.namingRoles($t(`roles.${role.name}`))}}</h4>
        </div>
        <form class="add-user-form" id='edit-provider' method="POST">
            <input type="hidden" name="_method" value="put" />
            <div class="row">
                <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                    <b-form-group>
                        <template slot="label">
                            <h4> {{$t('placeholder.tipDePermisiuni')}} </h4>
                            <b-form-checkbox
                                    v-model="allSelected"
                                    :indeterminate="indeterminate"
                                    aria-describedby="permissions"
                                    aria-controls="permissions"
                                    @change="toggleAll"
                            >
                                {{ allSelected ? 'Deselecteaza toate' : 'Selecteaza toate' }}
                            </b-form-checkbox>
                        </template>
                        <div class="permissions-alert-group">
                            <div class="permissions-cell">
                                <h4> {{$t('placeholder.permisiuneVizualizareLista')}} <i class="far fa-caret-square-down"></i> </h4>
                                <b-form-checkbox-group
                                        class="checkbox-roles"
                                        v-model="checkedPermissions"
                                        :options="permissionCategory1"
                                        text-field="name"
                                        value-field="id"
                                        stacked
                                ></b-form-checkbox-group>
                            </div>
                            <div class="permissions-cell">
                                <h4> {{$t('placeholder.permisiuneCreeare')}} <i class="far fa-caret-square-down"></i> </h4>
                                <b-form-checkbox-group
                                        class="checkbox-roles"
                                        v-model="checkedPermissions"
                                        :options="permissionCategory2"
                                        text-field="name"
                                        value-field="id"
                                        stacked
                                ></b-form-checkbox-group>
                            </div>
                            <div class="permissions-cell">
                                <h4> {{$t('placeholder.permisiuneVizualizareDetalii')}}  <i class="far fa-caret-square-down"></i> </h4>
                                <b-form-checkbox-group
                                        class="checkbox-roles"
                                        v-model="checkedPermissions"
                                        :options="permissionCategory3"
                                        text-field="name"
                                        value-field="id"
                                        stacked
                                ></b-form-checkbox-group>
                            </div>
                            <div class="permissions-cell">
                                <h4> {{$t('placeholder.permisiuneActualizare')}} <i class="far fa-caret-square-down"></i> </h4>
                                <b-form-checkbox-group
                                        class="checkbox-roles"
                                        v-model="checkedPermissions"
                                        :options="permissionCategory4"
                                        text-field="name"
                                        value-field="id"
                                        stacked
                                ></b-form-checkbox-group>
                            </div>
                            <div class="permissions-cell">
                                <h4> {{$t('placeholder.permisiuneStergere')}} <i class="far fa-caret-square-down"></i> </h4>
                                <b-form-checkbox-group
                                        class="checkbox-roles"
                                        v-model="checkedPermissions"
                                        :options="permissionCategory5"
                                        text-field="name"
                                        value-field="id"
                                        stacked
                                ></b-form-checkbox-group>
                            </div>
                        </div>
                    </b-form-group>
                </div>
            </div>
            <div class="save-permission-roles">
                <button type="button" @click='savePermissions()'>
                    <i class="fas fa-check"></i>
                    {{$t('placeholder.salveaza')}}
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import RolesService from '../../api-services/roles.service.js'
export default {
  name: 'Editrole',
  data () {
    return {
      allSelected: false,
      role: null,
      permissions: [],
      checkedPermissions: [],
      indeterminate: false
    }
  },
  watch: {
    checkedPermissions (newVal, oldVal) {
      // Handle changes in individual flavour checkboxes
      if (newVal.length === 0) {
        this.indeterminate = false
        this.allSelected = false
      } else if (newVal.length === this.permissions.length) {
        this.indeterminate = false
        this.allSelected = true
      } else {
        this.indeterminate = true
        this.allSelected = false
      }
    }
  },
  methods: {
    toggleAll (checked) {
      this.checkedPermissions = checked ? this.permissions.map(o => o.id) : []
    },
    getAllPermission () {
      return new Promise((resolve, reject) => {
        RolesService.getAllPermissions()
          .then((response) => {
            this.permissions = response.data.data
            resolve(response)
          })
          .catch((error) => {
            console.log(error)
            reject(error)
          })
      })
    },
    getRolePermission () {
      return new Promise((resolve, reject) => {
        RolesService.get(this.$route.params.id)
          .then((response) => {
            this.role = response.data.data
            this.checkedPermissions = response.data.data.permissions.map(o => o.id)
            // this.checkedPermissions = response.data.data.permissions
            this.$store.dispatch('hideLoading')
            resolve(response)
          })
          .catch((error) => {
            console.log(error)
            this.$store.dispatch('hideLoading')
            reject(error)
          })
      })
    },
    savePermissions () {
      this.$store.dispatch('showLoading')
      RolesService.update(this.$route.params.id, { permissions: this.checkedPermissions })
        .then((response) => {
          this.$store.dispatch('hideLoading')
          this.$notify({
            group: 'succes',
            type: 'success',
            // title: 'Added',
            text: this.$t('success.permissionsSaved'),
            'animation-type': 'css'
          })
          // this.$router.push('/roles')
        })
        .catch((error) => {
          this.$store.dispatch('hideLoading')
          this.$notify({
            group: 'error',
            type: 'error',
            title: this.$t('errors.errorTitle'),
            text: error.response.data.error,
            'animation-type': 'css'
          })
        })
    }
  },
  computed: {
    permissionCategory1 () {
      let vm = this
      return this.permissions.filter(function (data) {
        if (parseInt(data.category) === 1) {
          data.name = vm.$t(`permissions.${data.name}`)
          return data
        }
      })
    },
    permissionCategory2 () {
      let vm = this
      return this.permissions.filter(function (data) {
        if (parseInt(data.category) === 2) {
          data.name = vm.$t(`permissions.${data.name}`)
          return data
        }
      })
    },
    permissionCategory3 () {
      let vm = this
      return this.permissions.filter(function (data) {
        if (parseInt(data.category) === 3) {
        // Commented now
          /*  let permissionWithoutDuplicates = [...new Set(vm.checkedPermissions.map(item => item))]
          if (data.name === 'Vizualizare Adaos') {
            if (!permissionWithoutDuplicates.includes(data.id)) {
              vm.checkedPermissions.push(data.id)
            }
          }/!* *!/ */
          data.name = vm.$t(`permissions.${data.name}`)
          return data
        }
      })
    },
    permissionCategory4 () {
      let vm = this
      return this.permissions.filter(function (data) {
        if (parseInt(data.category) === 4) {
          data.name = vm.$t(`permissions.${data.name}`)
          return data
        }
      })
    },
    permissionCategory5 () {
      let vm = this
      return this.permissions.filter(function (data) {
        if (parseInt(data.category) === 5) {
          data.name = vm.$t(`permissions.${data.name}`)
          return data
        }
      })
    }
  },
  async created () {
    await this.getAllPermission()
    await this.getRolePermission()
  }
}
</script>
